import performanceTracker from 'src/utils/performanceTracker';

/* setTimeout is used to carry the performanceTracker.report()
* to the top of the call stack so that it's executed after window.load
* setTimeout(() => performanceTracker.report());
*/

export default () => {
  const loadEventEnd = performance.timing.loadEventEnd;

  if (loadEventEnd) {
    return setTimeout(performanceTracker.report);
  }

  window.addEventListener('load', () => {
    setTimeout(performanceTracker.report);
  });
};
